import API from 'aurora-api';
import * as urls from 'aurora-api/urls';
import { ACTIVE_URL } from 'aurora-utils/constants';

const { BASE_URL } = ACTIVE_URL;

const api = new API(BASE_URL);

class PrimaryContactService {
  static getContacts = data => api.post(urls.PRIMARY_CONTACT.FETCH_CONTACTS, null, data);

  static getApplicationContacts = data => api.post(urls.PRIMARY_CONTACT.FETCH_APPLICATION_CONTACTS, data);

  static addContact = data => api.post(urls.PRIMARY_CONTACT.ADD_CONTACT, data);

  static addApplicationContact = data => api.post(urls.PRIMARY_CONTACT.ADD_APPLICATION_CONTACT, data);

  static removeContact = id => {
    const url = urls.PRIMARY_CONTACT.REMOVE_CONTACT;

    return api.delete(`${url}/${id}`);
  };

  static fetchBuyerList = data => api.get(urls.OFFPLAN.BUYER_LIST, null, data);

  static addBuyer = data => api.post(urls.OFFPLAN.ADD_BUYER_NON_RESIDENT, data);
}

export default PrimaryContactService;
